 import React from 'react'
import StudentSmsTools from './StudentSmsTools'
import { Button, FormControl, Grid, InputLabel, Select, TextField } from '@mui/material'
import { useState } from 'react'

const StudentSms = () => {
    const [branch,setBranch]=useState('');
    const [branchList,setBranchList]=useState([]);
    const [semester,setSemester]=useState('');
    const [semesterList,setSemesterList]=useState([]);
    const [college,setCollege]=useState('');
    const [collegeList,setCollegeList]=useState([]);

    const onBranchChange=(e)=>{
        setBranch(e.target.value);
    }

    const onSemesterChange=(e)=>{
        setSemester(e.target.value);
    }

    const onCollegeChange=(e)=>{
        setCollege(e.target.value);
    }

    return (
        <div>
            <form>
                <Grid container spacing={2} style={{display:'flex'}}>
                    <Grid container  item xs={8} sm={8} md={8} lg={8} xl={8} style={{border:'solid',borderColor:'whitesmoke',marginTop:'30px',marginLeft:'70px',height:'60vh',width:'100%'}}>
                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12} style={{alignSelf:'center', textAlign:'center'}}>
                            <h1>SMS</h1>
                            <hr />
                        </Grid>
                        <Grid container spacing={2} >
                            <Grid item xs={12} sm={12} md={4} lg={4} xl={4} >
                                <FormControl fullWidth>
                                    <InputLabel id="demo-simple-select-label">Select Branch</InputLabel>
                                    <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    label="Select Location"
                                    placeholder='Select Location'
                                    required
                                    value={branch}
                                    onChange={(e) => onBranchChange(e) }>
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={12} md={4} lg={4} xl={4} >
                                <FormControl fullWidth>
                                    <InputLabel id="demo-simple-select-label">Select Year</InputLabel>
                                    <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    label="Select Location"
                                    placeholder='Select Location'
                                    required
                                    value={semester}
                                    onChange={(e) => onSemesterChange(e) }>
                                    </Select>
                                </FormControl>           
                            </Grid>
                            <Grid item xs={12} sm={12} md={4} lg={4} xl={4} style={{marginRight:'0px'}}>
                                <FormControl fullWidth>
                                    <InputLabel id="demo-simple-select-label">Select College</InputLabel>
                                    <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    label="Select Location"
                                    placeholder='Select Location'
                                    required
                                    value={college}
                                    onChange={(e) => onCollegeChange(e) }>
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6} md={6} lg={6} xl={6} >
                                <TextField
                                id="outlined-textarea"
                                label="Message"
                                placeholder="Placeholder"
                                multiline />
                            </Grid>
                        </Grid>
                        <Grid container spacing={2} style={{marginTop:'10px',marginBottom:'20px'}}>                 
                            <Grid item xs={10} sm={10} md={6} lg={6} xl={6} >
                                <Button style={{marginLeft:'10px'}} type="submit" variant="contained">Send SMS</Button>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid> 
            </form>
        </div>   
    )
}

export default StudentSms

